import Axios from 'axios';

export async function getEnderecoByCep(cep) {
  try {
    const response = await Axios.get(
      `https://viacep.com.br/ws/${cep.replace(/\D/g, '')}/json`
    );

    const data = {
      ...response.data,
      cidade: response.data.localidade,
      cep: response.data.cep.replace(/\D/g, ''),
      estado: response.data.uf,
    };

    return data;
  } catch (error) {
    return null;
  }
}
